import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

// Angular has no validator for the native `step` attribute, so this enforces a max number of decimal places.
@Directive({
  selector: '[decimalPlaces][ngModel],[decimalPlaces][formControl],[decimalPlaces][formControlName]',
  standalone: false,
  providers: [{ provide: NG_VALIDATORS, useExisting: DecimalPlacesDirective, multi: true }],
})
export class DecimalPlacesDirective implements Validator {
  @Input('decimalPlaces') places: number = 2;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // String(number) can produce exponent form (e.g. 1e-7), so count mantissa decimals minus the exponent
    const match = /^-?\d*(?:\.(\d+))?(?:e([+-]?\d+))?$/i.exec(String(value));
    if (!match) {
      return null;
    }

    const decimals = Math.max(0, (match[1]?.length ?? 0) - Number(match[2] ?? 0));
    return decimals > this.places ? { decimalPlaces: { places: this.places, actual: decimals } } : null;
  }
}
